import { useEffect, useState, Fragment } from 'react';
import Header from "../../../Common/header";
import Footer from "../../../Common/footer";
import MyFiles from './PortalTabs/MyFiles';
import Information from './PortalTabs/Information';
import ImageUpload from './FileUploads/UploadImage';
import VideoUpload from './FileUploads/UploadVideo';
import GPXUpload from './FileUploads/UploadGPX';
import PDFUpload from './FileUploads/UploadPDF';
import EditPage from './Edit/EditVisualization';
import { HiPlus, HiOutlineDocumentText, HiOutlineInformationCircle } from "react-icons/hi";
import { Link } from "react-router-dom";
import ResponseNotification from "../../Admin/UserManagement/Modals/responseNotification";
import AddVisualization from './PortalTabs/AddVisualization';
import useDocumentTitle from '../../../Common/useDocumentTitle';


export default function CreatePortal(props) {
  const [currentTab, setCurrentTab] = useState(0);
  const [renderPage, setRenderPage] = useState(0);

  const [notificationShow, setNotificationShow] = useState(props.location.state?.notificationShow || false);
  const [notificationPurpose, setNotificationPurpose] = useState("");
  const [notification, setNotification] = useState(props.location.state?.notification || 
    {
      status: false,
      title: "",
      message: "",
    }
  );

  useDocumentTitle("Visualization");

  const secondaryNavigation = [
    { name: 'Add Visualization', href: '', icon: HiPlus, componentName: AddVisualization, current: true },
    { name: 'My Files', href: '/my-files', icon: HiOutlineDocumentText, componentName: MyFiles, current: false },
    { name: 'Information', href: '/information', icon: HiOutlineInformationCircle, componentName: Information, current: false },
  ]

  /**
   * Calls initialView on load.
   */
  useEffect(() => {
    initialView();
  }, []);

  /**
   * Sets the correct initial tab and rendered page based on the url.
   */
  const initialView = () => {
    if(window.location.href.includes("edit")){
      setCurrentTab(1);
      setRenderPage(7);
    }
    else if(window.location.href.includes("my-files")){
      setCurrentTab(1);
      setRenderPage(1);
    }
    else if(window.location.href.includes("information")){
      setCurrentTab(2);
      setRenderPage(2);
    }
    else if(window.location.href.includes("upload-image")){
      setCurrentTab(0);
      setRenderPage(3);
    }
    else if(window.location.href.includes("upload-video")){
      setCurrentTab(0);
      setRenderPage(4);
    }
    else if(window.location.href.includes("upload-pdf")){
      setCurrentTab(0);
      setRenderPage(5);
    }
    else if(window.location.href.includes("upload-gpx")){
      setCurrentTab(0);
      setRenderPage(6);
    }
  }

  /**
   * Renders the current view.
   * @returns The view to render.
   */
  function renderCurrentView() {
    let Component = <></>;

    switch(renderPage){
      case 0:
        Component = AddVisualization;
        break;
      case 1:
        Component = MyFiles;
        break;
      case 2:
        Component = Information;
        break;
      case 3:
        Component = ImageUpload;
        break;
      case 4:
        Component = VideoUpload;
        break;
      case 5:
        Component = PDFUpload;
        break;
      case 6:
        Component = GPXUpload;
        break;
      case 7:
        Component = EditPage;
        break;
    }

    return <Component 
            setNotificationPurpose={setNotificationPurpose} 
            setNotificationShow={setNotificationShow}
            setNotification={setNotification}
          />;
  }

  function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
  }

  return (
    <>
      <Header />

      <div className="dark:bg-gray-900">
        <div className='mx-auto max-w-6xl lg:flex lg:gap-x-8 lg:px-8 '>
        <aside className="flex overflow-x-auto border-b border-gray-900/5 py-4 lg:block lg:w-64 lg:flex-none lg:border-0 lg:py-20">
          <nav className="flex-none px-4 sm:px-6 lg:px-0">
            <ul role="list" className="flex gap-x-3 gap-y-1 whitespace-nowrap lg:flex-col">
              {secondaryNavigation.map((item, index) => {
                return (
                <li key={item.name}>
                  <Link
                    data-cy={item.name}
                    to={`/visualization${item.href}`}
                    className={classNames(
                      index === currentTab
                        ? 'bg-gray-50 text-blue-600 dark:bg-gray-800 dark:text-white'
                        : 'text-gray-700 hover:text-blue-600 hover:bg-gray-50 dark:text-gray-400 dark:hover:text-white dark:hover:bg-gray-800',
                      'group flex gap-x-3 rounded-md py-2 pl-2 pr-3 text-sm leading-6 font-semibold'
                    )}
                  >
                    <item.icon
                      className={classNames(
                        index === currentTab ? 'text-blue-600' : 'text-gray-400 group-hover:text-blue-600',
                        'h-6 w-6 shrink-0'
                      )}
                      aria-hidden="true"
                    />
                    {item.name}
                  </Link>
                </li>
                )
              })}
            </ul>
          </nav>
        </aside>

        <ResponseNotification
          as={Fragment}
          show={notificationShow}
          notification={notification}
          setShow={setNotificationShow}
          notificationPurpose={notificationPurpose}
        />

        <main className="px-4 py-16 sm:px-6 lg:flex-auto lg:px-0 lg:py-20">
          {renderCurrentView()}
        </main>
        </div>
      </div>
      <Footer />
    </>
  );
}
